<!--
 * @Description: 客户代码下拉选择框
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-09-23 16:01:56
 * @LastEditors: cxh
-->
<template>
  <CosInputView v-if="view" :value="data" />
  <CosSelect
    v-else
    v-model:value="data"
    style="width: 100%"
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="fetchCode"
    @change="change"
  >
    <a-select-option
      v-for="item in optionPage"
      :disabled="disabledData.includes(item.arkCode) && data !== item.arkCode ? true : false"
      :key="item.id"
      :value="item.arkCode"
      >{{ item.arkCode }}</a-select-option
    >
  </CosSelect>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, onActivated } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { getCosIdBindCode } from '@/api/overseasSales/customerCenter'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { debounce } from 'lodash-es'
const props = defineProps({
  value: {
    type: [String, Array, Number]
  },
  label: {
    type: [String, Array]
  },
  cosId: {
    type: String
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  disabledData: {
    type: Array,
    default: () => {
      return []
    }
  }
})

const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = defineEmits(['update:value', 'change'])
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      if (searchTxt.value) {
        fetchCode('')
      }
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  emit('update:value', value)
  emit('change', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt.trim()
  pageNumber.value = 1
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  getCosIdBindCode({
    pageNumber: pageNumber.value,
    pageSize: 100,
    arkCode: searchTxt.value,
    stage: props.stage,
    cosId: props.cosId
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  fetch()
})
onActivated(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  if (pageNumber.value === 1) {
    optionPage.value = []
    fetch()
  }
})
</script>
<script lang="ts">
export default { name: 'SerialSelect' }
</script>
